<template>
    <div class="fixed-scroller">
        <div class="edit-form v-alert-container">
            <div class="v-alert w-500" style="margin-top: -90px;">
                <header><p>{{ newMember ? 'New' : 'Edit' }} Member</p><div @click="exit('exit')" class="x"></div></header>
                <div class="edit-form-container">
                    <div class="label">
                        <p>Code</p>
                        <input v-model="customer.code" />
                    </div>
                    <div class="label">
                        <p>Name</p>
                        <input v-model="customer.name" />
                    </div>
                    <div class="label">
                        <p>Phone</p>
                        <input v-model="customer.phone" />
                    </div>
                    <div class="label w-33">
                        <p>Send SMS</p>
                        <input type="checkbox" v-model="customer.sendSMS" />
                    </div>
                    <div class="label w-33" style="margin-right:33%;">
                        <p>Send Email</p>
                        <input type="checkbox" v-model="customer.sendEMAIL" />
                    </div>
                    <div class="label">
                        <p>Email</p>
                        <input v-model="customer.email" />
                    </div>
                    <div class="label w-33">
                        <p>Manager</p>
                        <input type="checkbox" v-model="customer.manager" />
                    </div>
                    <div class="label w-33">
                        <p>Staff</p>
                        <input type="checkbox" v-model="customer.staff" />
                    </div>
                    <div class="label w-33">
                        <p>Demo</p>
                        <input type="checkbox" v-model="customer.demo" />
                    </div>                    
                    <div class="label">
                        <p>Notes</p>
                        <textarea v-model="customer.notes" style="width: calc(100% - 15px);max-width: calc(100% - 15px);min-width: calc(100px - 15px);min-height: 95px;padding:5px;font-size: 16px;"></textarea>
                    </div>
                    <div class="label">
                        <p class="btn big w-50" @click="changeClosed(customer)" :style="{ 'background-color': customer.closed ? 'red' : 'green' }">{{ customer.closed ? 'CLOSED' : 'ACTIVE' }}</p>
                        <p class="btn big w-50" @click="addScans(customer)" style="margin-left:20px">ADD SCANS</p>
                    </div>
                </div>
                <div class="v-btns">
                    <p class="btn del" @click="exit('delete')">delete</p>
                    <p class="btn" @click="exit('save')">save</p>
                </div>	
            </div>
        </div>
        <div v-if="!voucher && ads.length > 0">
            <div class="v-alert add-stamps">
                <header><p>Customer Offers</p><div class="x" @click="ads = []"></div></header>
                <div v-for="ad in ads" class="item">
                    <p class="ellip" @click="addScan(ad)">{{ ad.title }}</p>
                </div>
                <div v-for="loyal in loyalty" class="item">
                    <p class="ellip" @click="addLoyalty(loyal)">{{ loyal.text }}</p>
                </div>
            </div>
        </div>
        <div v-if="voucher">
            <div class="v-alert adding-voucher" style="width: 310px;margin-left: -155px">
                <header><p>Adding Scans</p><div class="x" @click="voucher = false"></div></header>
                <Voucher :voucher="voucher" style="height: 356px;" />
                <div v-if="!voucher.loyaltyReward">
                    <div class="label">
                        <p class="btn big" style="width: calc(100% - 2px);" @click="addClickRedeem(voucher)">{{ voucher.redeemAd ? 'REDEEM' : 'ADD CLICK' }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="stampReward">
            <div class="v-alert stamp-reward">
                <header><p>Adding Scans</p><div class="x" @click="stampReward = false"></div></header>
                <div :style="{ backgroundColor: backgroundColor }">
                    <p :style="{ color: fontColor }" class="reward-title">{{ stampReward.text }}</p>
                    <img :src="stampReward.rewardImg" style="width: 290px;height: 290px;margin-left:40px"/>
                </div>
                <div class="label w-50">
                    <p>Qty Stamps</p>
                    <input v-model.number="addStampQty" />
                </div>
                <div class="label w-50">
                    <p class="btn" style="margin-top: 22px;" @click="addStampNow(voucher,addStampQty)">ADD STAMPS</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

var $el;

import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import makeMSISDN from '@/utils/makeMSISDN.js'
import Voucher from '@/components/Voucher.vue';

export default {
    props: ['item'],
    components: {
        Voucher
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        auth () { 
            var state = this.$store.state;
            return {
                user_id: state.staff_id,
                un: state.username,
                client_id: state.client_id
            }
        }
    },
    data () {
        return {
            db: '',
            width: 500,
            show: false,
            initial: false,
            newMember: false,
            voucher: false,
            addStampQty: '',
            stampReward: false,
            backgroundColor: '',
            fontColor: '',
            coupon: false,
            ads: [],
            loyalty: [],
            customer: {
                code: '',
                name: '',
                phone: '',
                notes: '',
                msisdn: '',
                email: '',
                closed: false,
                manager: false,
                staff: false,
                demo: false,
                sendSMS: true,
                sendEMAIL: true
            }
        }
    },
    created () {
        if ( !this.item ) {
            var _id = this.$route.params.id;

            if ( _id == 'new' ) {
                this.newMember = true;
                return console.log('new Member');
            }
            
            return WebSoc.SEND('get',{ DB: this.client_id+'-customers', _id },item => {
                this.initial = JSON.stringify(item);
                this.customer = item;
                this.setCustomer();
            })

        } else {
            this.customer = JSON.parse(JSON.stringify(this.item));
            this.setCustomer();
        }

    },
    mounted () {

    },
    methods: {
        setCustomer () {
            this.customer.staff = this.customer.staff || false;
            this.customer.demo = this.customer.demo || false;
            this.customer.code = this.customer.code || '';
            this.customer.closed = this.customer.closed || false;
            this.customer.sendSMS = typeof this.customer.sendSMS == 'boolean' ?  this.customer.sendSMS : true;
            this.customer.sendEMAIL = typeof this.customer.sendEMAIL == 'boolean' ?  this.customer.sendEMAIL : true;           
        },
        addScans ( customer ) {
            this.stampReward = false;
            this.voucher = false;
            WebSoc.SEND('get',{ DB: this.client_id+'-customers', _id: customer._id },customer => {
                customer.ads.forEach(ad => { 
                    ad.title = ad.title || '';
                    !ad.title && WebSoc.SEND('get',{ DB: 'jb-ads', _id: ad.ad_id, project: { title: 1 }},Ad => {
                        ad.title = Ad.title;
                    });
                });
                this.ads = customer.ads;
                if ( this.ads.length == 0 ) Alert.message('No Ads for this Member');
            });
            WebSoc.SEND('get',{ DB: 'clients', _id: this.client_id, project: { menu: 1, backgroundColor: 1, fontColor: 1 } },client => {
                this.backgroundColor = client.backgroundColor;
                this.fontColor = client.fontColor;
                this.loyalty = client.menu.filter(m => m.page == 'loyalty');
                this.loyalty.forEach(l => {
                    l.ad = {};
                    WebSoc.SEND('get',{ DB: 'surveys', _id: l.campaign_id, project: { pages: 1 }},campaign => {                       
                        l.ad = campaign.pages[0];
                        l.ad.qty = this.customer[l.campaign_id] || 0;
                    })
                })
            })
        },
        addScan ( ad ) {
            ad.loyaltyReward = false;
            this.voucher = ad;
            WebSoc.SEND('get',{ DB: 'jb-coupons', _id: ad.coupon_id },coupon => {
                console.log('coupon.redeemAd',coupon.redeemAd);
                this.coupon = coupon;
            });
        },
        addClickRedeem ( ) {

            var coupon = this.coupon;
                
            WebSoc.SEND('redeemLoyaltyCoupon',{ coupon, query: {}, auth: this.auth },resp => {

                if ( resp.clicked ) {
                    this.addScans ( this.customer ); 
                    Alert.message('Click Added');
                }
                if ( resp.update ) {    
                    this.addScans ( this.customer ); 
                    Alert.message('Coupon Redeemed');
                }
                if ( resp.error ) Alert.message(resp.error);

            })
        },
        addLoyalty ( loyal ) {
            this.addStampQty = '';
            loyal.rewardImg = 'https://api.memberstar.club/loyalty/'+this.customer._id+'/'+loyal.campaign_id+'?d='+Date.now(); 
            this.stampReward = loyal;      
        },
        addStampNow ( voucher, qty ) {
            console.log({ qty })
            var stampReward = this.stampReward;
            if ( isNaN(qty) || qty == '' ) return Alert.message('Please enter a quantity');
            Alert.yesno('Add '+qty+' to '+stampReward.text+'?',yes => {
                if ( !yes ) return;
                WebSoc.SEND('awardCustomerLoyalty',{ qty, customer_id: this.customer._id, campaign_id: stampReward.campaign_id, auth: this.auth, client_id: this.client_id  },resp => {
                    setTimeout(() => {
                        stampReward.rewardImg += '&date='+Date.now();
                        this.$forceUpdate();
                    },1000);

                    if ( resp.complete > 0 ) {
                        Alert.message(this.customer.name+' has been sent the reward.')
                    } else if ( resp.awarded > 0 ) {
                        Alert.message(this.customer.name+' has now has '+resp.current+' stamps.');
                    }

                    if ( resp.update ) {    
                        Alert.message('Coupon Redeemed');
                    }
                    if ( resp.error ) Alert.message(resp.error);
                });
            })
        },
        changeClosed ( customer ) {
            customer.closed = !customer.closed;
            this.$forceUpdate();
        },
        emit ( data ) {
            console.log('emit data',data);
        },
        exit ( type ) {
            switch ( type ) {
                case 'exit':
                    if ( !this.item ) {
                        return this.$router.push('/members');
                    } else {
                        return this.$emit('emit',{ t: 'edit-member', action: 'exit' });
                    }
                case 'save':
                    return this.save();
                break;
                case 'delete':
                    return this.deleteCustomer();
                default:
                    console.log('What',type);
            }
        },
        deleteCustomer () {
            var customer = this.customer;
            if ( !customer.closed && !this.customer.closed ) return Alert.message('Connot delete a Member until the account is Closed');
            Alert.yesno('Delete '+customer.name+'?',yes => {
                if ( !yes ) return;
                WebSoc.SEND({ t: 'deleteCustomer', data: { customer_id: customer._id, client_id: customer.client_id } },resp => {
                    console.log('deleteCustomer resp',resp);
                    this.exit('exit');
                })
            })
        },
        save () {
            var { item, customer } = this;
            if ( !item ) item = JSON.parse(JSON.stringify(this.initial))            
            var update = ['phone','name','notes','closed','email','manager','sendSMS','sendEMAIL','code','demo','staff'].reduce((prev,f) => {
                if ( item[f] != customer[f] ) { prev[f] = customer[f] }
                return prev;
            },{})

            if ( typeof update.phone == 'string' ) {
                update.msisdn = makeMSISDN(update.phone);
            }
            if ( update.closed ) {
                update.closed = Date.now();
            }
            
            if ( Object.keys(update).length == 0 ) return this.exit('exit');
            WebSoc.SEND('updateCustomer',{ _id: item._id, db: this.client_id+'-customers', update, client_id: this.client_id },resp => {
                //Alert.message((this.newMember ? 'Added ' : 'Updated ')+customer.name || customer.phone);
                console.log('updateCustomer resp',resp);
                this.exit('exit');
            })
        }
    }
}

</script>

<style lang="scss">
.v-alert.stamp-reward {
    .reward-title {
        text-align: center;
        font-size: 25px;
        margin: 10px 0px 0px 0px;
        float: left;
        width: 100%;
    }
}    
.v-alert.adding-voucher {
    .ad-img {
        margin-bottom: -155px;
    }
}    
.v-alert.add-stamps {
    .item {
        width: calc(100% - 10px);
        padding: 5px;
        float: left;
        &:nth-child(odd) {
            background-color: rgba(200,200,200,0.4);
        }
        p {
            width: 100%;
            color: blue;
            text-decoration: underline;
        }
    }
}
</style>